<template>
	<div class="content">
		<div class="hero">
			<div class="title ml-5 mt-5" style="z-index: +3; color: white"><b style="font-size: 40px;">About Us Page</b></div>
			<v-img src="@/assets/moonlight.jpg" height="150" />
		</div>
		<v-container>		
			<div v-for="Document in documents" :key="Document.id" >
				<div v-if="Document.name === 'About Us' ">
					<span v-html="Document.description"></span>
				</div>
			</div>
		</v-container>
	</div>
</template>

<script>
	import {db} from '@/firebase';
	export default {
		name : "about",
		props: {
      msg: String
    },
    data: () => ({
      documents: [],
      nav_title: 'About Us Page',
    }),
    firestore() {
      return {
        documents: db.collection('documents')
      }
    },
    metaInfo: {
      // Children can override the title.
      title: 'About Us',
      // Result: My Page Title ← My Site
      // If a child changes the title to "My Other Page Title",
      // it will become: My Other Page Title ← My Site
      //       titleTemplate: '%s ← My Site',
      // Define meta tags here.
      meta: [
        // {http-equiv: 'X-UA-Compatible', content: 'IE=edge'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {name: 'description', content: 'This is not going to be given life only the read data pages'}
      ]
    }
	}
</script>

<style scoped>
  .title {
    position: absolute;
    top: 100px;
  }
</style>